import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ImportExportService } from './../../../../core/services/import-export.service';
import { AuthorizationProperties } from './../../../../authentication/auth-info';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from 'src/app/core/services/login.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { QuickNoteLevels } from 'src/app/model/ImportExportManagement';
import { DbInfoBag } from 'src/app/database/helpers/db-info-bag';
import { ExportDataBodyContent } from 'src/app/database/helpers/database-helpers';
import { MiniStorageService } from 'src/app/core/services/mini-storage.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AlertDialogComponent } from 'src/app/store/dialogs/alert-dialog/alert-dialog.component';
import { StepperOrientation } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MatSort } from '@angular/material/sort';
import { ChecklistDatabase, ImpExpTreeNode } from '../check-list-database';
import { AppSubscription } from 'src/app/model/subscription';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { LoadingService } from 'src/app/core/services/loading.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'ms-export-management',
    templateUrl: './export-management.component.html',
    styleUrls: ['./export-management.component.scss'],
    providers: [ChecklistDatabase],
})
export class ExportManagementComponent implements OnInit {
    isExporting = false;
    isLoadingExportList = false;
    importKey: string;
    countFilesToImport = 0;
    logs: string = undefined;
    public showMore = false;
    isStepComplete: boolean = false;
    stepperOrientation: Observable<StepperOrientation>;
    TREE_DATA_local: any = undefined;
    @ViewChild('stepper', { static: false }) myStepper: MatHorizontalStepper;

    showProcessStarted = false;
    showListTables = false;

    choiseMade = false;

    noteLevel: QuickNoteLevels = QuickNoteLevels.Info;
    noteTitle = 'Import data has been started';
    noteText =
        'This process has been started and it may take a few minutes to complete. You will receive a notification when the operation will be done.';

    public mng_impexp_title: string;
    public mng_impexp_descri: string;
    public cmsObj: CmsObject[];
    language: string;

    favoriteTreeView = false;

    public loading: boolean = false;

    subSelected: AppSubscription;
    subKeySelected: string;
    subDescriSelected: string;
    tablesSelectedList: ImpExpTreeNode[];

    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);

    dbInfoBag: DbInfoBag;
    _paginatorFiles: MatPaginator;
    filesT: MatTableDataSource<string>;
    favoriteExport: string = undefined;
    @ViewChild('filesPaginator') set filesPaginator(content: MatPaginator) {
        if (content) {
            // initially setter gets called with undefined
            this._paginatorFiles = content;
            const paginatorIntl = this._paginatorFiles._intl;
            paginatorIntl.nextPageLabel = this.variable.nextPage;
            paginatorIntl.previousPageLabel = this.variable.previousPage;
            if (this.filesT) {
                this.filesT.paginator = this._paginatorFiles;
            }
        }
    }
    searchText: string = null;

    @ViewChild('filesTable', { static: false }) accountsTable: MatTable<any>;

    displayedColumnsFiles: string[] = ['FileName', 'Download'];

    @ViewChild(MatSort, { static: false }) filesSort: MatSort;
    /** Map from flat node to nested node. This helps us finding the nested node to be modified */
    flatNodeMap = new Map<ImpExpTreeNode, ImpExpTreeNode>();

    /** Map from nested node to flattened node. This helps us to keep the same object for selection */
    nestedNodeMap = new Map<ImpExpTreeNode, ImpExpTreeNode>();

    /** A selected parent node to be inserted */
    selectedParent: ImpExpTreeNode | null = null;

    /** The new item's name */
    newItemName = '';

    treeControl: FlatTreeControl<ImpExpTreeNode>;

    treeFlattener: MatTreeFlattener<ImpExpTreeNode, ImpExpTreeNode>;

    dataSource: MatTreeFlatDataSource<ImpExpTreeNode, ImpExpTreeNode>;

    /** The selection for checklist */
    checklistSelection = new SelectionModel<ImpExpTreeNode>(true /* multiple */);
    //
    /**
     * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
     */
    transformer = (node: ImpExpTreeNode, level: number) => {
        const existingNode = this.nestedNodeMap.get(node);
        const flatNode = existingNode && existingNode.name === node.name ? existingNode : new ImpExpTreeNode();
        flatNode.name = node.name;
        flatNode.level = level;
        flatNode.expandable = !!node.children?.length;
        this.flatNodeMap.set(flatNode, node);
        this.nestedNodeMap.set(node, flatNode);
        return flatNode;
    };

    constructor(
        private importExportService: ImportExportService,
        private loginService: LoginService,
        private variable: TranslatedVariables,
        private cmsService: CmsService,
        private workFlow: WorkFlowService,
        private miniStorage: MiniStorageService,
        private dialog: MatDialog,
        private _database: ChecklistDatabase,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public loadingService: LoadingService,
        private breakpointObserver: BreakpointObserver

    ) {
        this.stepperOrientation = breakpointObserver
        .observe('(min-width: 1600px)')
        .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));

        this.filesT = new MatTableDataSource<string>();

        this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
        this.treeControl = new FlatTreeControl<ImpExpTreeNode>(this.getLevel, this.isExpandable);
        this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

        _database.dataChange.subscribe((data) => {
            this.dataSource.data = data;
        });
    }

    async ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params) {
                window.history.replaceState({}, '', `/import-export-home/export-data`);
            }
            this.subKeySelected = params.subKeySelected;
        });



            this.dbInfoBag = new DbInfoBag();

        this.miniStorage.get('imp-subkey-' + this.subKeySelected).subscribe((res) => {
            if (res !== undefined) {
                this.subSelected = res;
                this.subDescriSelected = res.Description;
                const subscriptionModel = new AppSubscription();
                subscriptionModel.SubscriptionKey = res.SubscriptionKey;
                subscriptionModel.SubscriptionToken = res.SubscriptionToken;
                subscriptionModel.Description = res.Description;
                this.dbInfoBag.SubscriptionModel = subscriptionModel;
            } else this.AlertSessionExpired();
        });
        await this.getCmsObj();
        this.dbInfoBag = new DbInfoBag();
        const authorizationStored = this.loginService.getauthinfo();

        if (authorizationStored === null || authorizationStored === undefined) {
            alert('DatabaseHomeComponent: User must be logged in.');
            return;
        }
        this.authorizationProperties = JSON.parse(authorizationStored);
        // inizializzo account corrente
        this.dbInfoBag.AccountName = this.authorizationProperties.accountName;
        this.filesT.paginator = this.filesPaginator;
        this.filesT.sort = this.filesSort;

        this.dbInfoBag.SubscriptionKey = this.subSelected.SubscriptionKey;
        this.favoriteExport = 'entireDb';
    }

    // --------------------------------------------------------------------------
    public AlertSessionExpired() {
        let quotationDialog = this.dialog.open(AlertDialogComponent, {
            data: {
                Title: this.variable.sessionExpiredTitle,
                Message: this.variable.sessionExpiredMessage,
            },
        });

        quotationDialog.afterClosed().subscribe(async () => {
            this.router.navigate(['/import-export-home']);
        });
    }

    // -----------------------------------------------------------------------------
    loadTables() {
        this.showListTables = true;

        if (this.TREE_DATA_local === undefined) {
            this.loading = true;
            this.loadingService.setLoading(this.loading);
            let opRes = this.importExportService.getListAppsMods(this.subKeySelected).subscribe(
                (opRes) => {
                    this.myStepper.next();
                    if (!opRes['Result']) {
                        this.workFlow.showMessage(this.variable.errorTitle, opRes['Message']);
                        this.loading = false;
                        this.loadingService.setLoading(this.loading);
                        this.myStepper.previous();
                        return;
                    }
                    let listOfAM = opRes['Content'];
                    let r: ImpExpTreeNode[] = JSON.parse(listOfAM);
                    const data = this._database.buildFileTree(r, 0);
                    this.TREE_DATA_local = data;
                    this.loading = false;
                    this.loadingService.setLoading(this.loading);
                    // Notify the change.
                    this._database.dataChange.next(data);
                },
                (err: HttpErrorResponse) => {
                    this.workFlow.showMessage(this.variable.errorTitle, err.message);
                    this.loading = false;
                    this.loadingService.setLoading(this.loading);
                    this.clean();
                    opRes.unsubscribe();
                }
            );
        }
    }

    // -----------------------------------------------------------------------------
    goToSummary() {
        this.showListTables = false;
        this.myStepper.next();
    }
    public hideDetails(fragment: string) {
        this.showMore = false;
        if (!document.getElementById(fragment)) return;
        document.getElementById(fragment).className = 'line-clamp';
    }
    public showDetails(fragment: string) {
        this.showMore = true;
        if (!document.getElementById(fragment)) return;
        document.getElementById(fragment).className = '';
    }
    // -----------------------------------------------------------------------------
    doExportData() {
        this.isStepComplete = true;

        if (this.isExporting) {
            this.dialog.open(AlertDialogComponent, {
                data: {
                    Title: 'Export data',
                    Message: 'Elaboration in progress, please wait for its completion',
                },
            });
            return;
        }
        this.loading = true;
        this.loadingService.setLoading(this.loading);

        // fill values in class to sent to back-end in the body
        const exportBodyContent: ExportDataBodyContent = new ExportDataBodyContent();
        exportBodyContent.Database = this.dbInfoBag.SubscriptionDatabaseModel;
        // considero solo i nodi senza figli
        this.checklistSelection.selected.forEach(element => { if (element.expandable == false) exportBodyContent.Tables.push(element) });

        const authorizationStored = this.loginService.getauthinfo();
        if (authorizationStored !== null && authorizationStored !== undefined) {
            const authorizationProperties: AuthorizationProperties = JSON.parse(authorizationStored);
            // propago l'AccountName
            exportBodyContent.AccountName = authorizationProperties.accountName;
        }

        this.isExporting = true;
        this.showProcessStarted = true;

        // esportazione file
        const exportData = this.importExportService.exportData(this.dbInfoBag.SubscriptionKey, exportBodyContent).subscribe(
            (exportDataResult) => {
                this.myStepper.next();

                if (exportDataResult === null || exportDataResult === undefined) {
                    console.log('DatabaseExportDataComponent exportDataResult is null');
                    this.loading = false;
                    this.loadingService.setLoading(this.loading);
                    exportData.unsubscribe();
                    return;
                }

                if (!exportDataResult.Result) {
                    this.logs = exportDataResult !== null ? exportDataResult.Message : 'An error occurred calling ExportData';
                }

                this.loading = false;
                this.loadingService.setLoading(this.loading);

                // this.logs = exportDataResult.Message;
                this.isExporting = false;
                this.refreshFrame();
                exportData.unsubscribe();
            },
            (exportDataError: HttpErrorResponse) => {
                alert(exportDataError.message);
                this.logs = exportDataError.message;
                this.isExporting = false;
                this.loading = false;
                this.loadingService.setLoading(this.loading);
                exportData.unsubscribe();
            }
        );
    }

    // -----------------------------------------------------------------------------
    goToHistoryExport() {
        this.miniStorage.set('imp-subkey-' + this.subKeySelected, this.subSelected, 15);

        this.router.navigate(['/import-export-home/history-imp-exp'], {
            queryParams: { subKeySelected: this.subKeySelected },
        });
    }

    // -----------------------------------------------------------------------------
    getTableList(index: number) {
        this.tablesSelectedList = [];
        if (index !== 0) {
            this.tablesSelectedList = this.checklistSelection.selected.filter((u) => u.level === index);
        }
        return this.tablesSelectedList;
    }

    // -----------------------------------------------------------------------------
    changeFavExport() {
        this.checklistSelection = new SelectionModel<ImpExpTreeNode>(true /* multiple */);
    }

    // -----------------------------------------------------------------------------
    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'accountcomponent');
        this.mng_impexp_title = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_title').ContentTranslation;
        this.mng_impexp_descri = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_descri').ContentTranslation;
    }

    // -----------------------------------------------------------------------------
    clean() {
        this.dbInfoBag = null;
        this.isExporting = false;
        this.showProcessStarted = false;
        this.choiseMade = false;

        this.router.navigate(['/import-export-home']);
    }

    // -----------------------------------------------------------------------------
    clearTablesSearch() {
        this.filterChanged('');
    }

    grafanaLogsExtracted: string[];
    // -----------------------------------------------------------------------------
    async refreshFrame() {
        let v = await this.getSrc();
        this.grafanaLogsExtracted = v.Content as string[];
    }

    // -----------------------------------------------------------------------------
    async getSrc() {
        const getLogsRes = await this.importExportService.getGrafanaLogsToPromise(
            this.dbInfoBag.SubscriptionKey,
            this.dbInfoBag.AccountName
        );
        if (getLogsRes === null || getLogsRes === undefined) {
            console.log('getGrafanaLogs: getLogsRes is null');
            return null;
        }

        if (!getLogsRes.Result) {
            this.logs = getLogsRes !== null ? getLogsRes.Message : 'An error occurred calling ImportData';
        }

        return getLogsRes;
    }

    getLevel = (node: ImpExpTreeNode) => node.level;

    isExpandable = (node: ImpExpTreeNode) => node.expandable;

    getChildren = (node: ImpExpTreeNode): ImpExpTreeNode[] => node.children;

    hasChild = (_: number, _nodeData: ImpExpTreeNode) => _nodeData.expandable;

    hasNoContent = (_: number, _nodeData: ImpExpTreeNode) => _nodeData.name === '';

    /** Whether all the descendants of the node are selected. */
    descendantsAllSelected(node: ImpExpTreeNode): boolean {
        const descendants = this.treeControl.getDescendants(node);
        const descAllSelected =
            descendants.length > 0 &&
            descendants.every((child) => {
                return this.checklistSelection.isSelected(child);
            });
        return descAllSelected;
    }

    /** Whether part of the descendants are selected */
    descendantsPartiallySelected(node: ImpExpTreeNode): boolean {
        const descendants = this.treeControl.getDescendants(node);
        const result = descendants.some((child) => this.checklistSelection.isSelected(child));
        return result && !this.descendantsAllSelected(node);
    }

    /** Toggle the to-do item selection. Select/deselect all the descendants node */
    todoItemSelectionToggle(node: ImpExpTreeNode): void {
        this.checklistSelection.toggle(node);
        const descendants = this.treeControl.getDescendants(node);
        this.checklistSelection.isSelected(node)
            ? this.checklistSelection.select(...descendants)
            : this.checklistSelection.deselect(...descendants);

        // Force update for the parent
        descendants.forEach((child) => this.checklistSelection.isSelected(child));
        this.checkAllParentsSelection(node);
    }

    /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
    // check on single table
    todoLeafItemSelectionToggle(node: ImpExpTreeNode): void {
        this.checklistSelection.toggle(node);
        this.checkAllParentsSelection(node);
    }

    filterChanged(filterText: string) {
        this._database.filter(filterText, this.TREE_DATA_local);
        if (filterText) {
            this.treeControl.expandAll();
        } else {
            this.treeControl.collapseAll();
        }
    }

    highlightStrings(filterText: string) {}

    /* Checks all the parents when a leaf node is selected/unselected */
    checkAllParentsSelection(node: ImpExpTreeNode): void {
        let parent: ImpExpTreeNode | null = this.getParentNode(node);
        while (parent) {
            this.checkRootNodeSelection(parent);
            parent = this.getParentNode(parent);
        }
    }

    /** Check root node checked state and change it accordingly */
    // check on module node
    checkRootNodeSelection(node: ImpExpTreeNode): void {
        const nodeSelected = this.checklistSelection.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        const descAllSelected =
            descendants.length > 0 &&
            descendants.every((child) => {
                return this.checklistSelection.isSelected(child);
            });
        if (nodeSelected && !descAllSelected) {
            this.checklistSelection.deselect(node);
        } else if (!nodeSelected && descAllSelected) {
            this.checklistSelection.select(node);
        }
    }

    /* Get the parent node of a node */
    getParentNode(node: ImpExpTreeNode): ImpExpTreeNode | null {
        const currentLevel = this.getLevel(node);

        if (currentLevel < 1) {
            return null;
        }

        const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

        for (let i = startIndex; i >= 0; i--) {
            const currentNode = this.treeControl.dataNodes[i];

            if (this.getLevel(currentNode) < currentLevel) {
                return currentNode;
            }
        }
        return null;
    }

    /** Select the category so we can insert the new item. */
    addNewItem(node: ImpExpTreeNode) {
        const parentNode = this.flatNodeMap.get(node);
        this._database.insertItem(parentNode!, '');
        this.treeControl.expand(node);
    }

    /** Save the node to database */
    saveNode(node: ImpExpTreeNode, itemValue: string) {
        const nestedNode = this.flatNodeMap.get(node);
        this._database.updateItem(nestedNode!, itemValue);
    }

    collapseExpandChange() {
        if (!this.favoriteTreeView) this.treeControl.expandAll();
        else this.treeControl.collapseAll();
        this.favoriteTreeView = !this.favoriteTreeView;
    }
}
